'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var renderHelper = function renderHelper(item, index) {
  return _react2.default.createElement(
    'li',
    { key: index },
    _react2.default.createElement(
      'a',
      {
        href: item.href,
        'data-pa-click': 'HeaderSubnav' + index + '-Link-' + item.text
      },
      item.text,
      item.subtext ? _react2.default.createElement(
        'em',
        null,
        item.subtext
      ) : null
    )
  );
};

var MPPSubnav = function (_Component) {
  _inherits(MPPSubnav, _Component);

  function MPPSubnav(props) {
    _classCallCheck(this, MPPSubnav);

    var _this = _possibleConstructorReturn(this, (MPPSubnav.__proto__ || Object.getPrototypeOf(MPPSubnav)).call(this, props));

    _this.generateClassNames = function (isOpen, isClosing) {
      return (0, _classnames2.default)('pypl-header__subnav-control', 'main-link', {
        'pypl-header__subnav-control--is-active': isOpen,
        'pypl-header__subnav-control--is-closing': isClosing,
        'pypl-header__subnav-control--is-highlighted': isOpen || _this.state.locationMatched
      });
    };

    _this.renderSubmenuCols = function (content) {
      var subnavLinks = content.subnavLinks;

      var cols = [];
      var totalLinks = subnavLinks.length;
      var colsClassname = 'submenu-cols';

      if (totalLinks < 7) {
        for (var i = 0; i < totalLinks; i += 1) {
          cols.push(_react2.default.createElement(
            'ul',
            { className: 'submenu-col', key: 'subnav-' + i },
            renderHelper(subnavLinks[i], i),
            subnavLinks[i + 1] ? renderHelper(subnavLinks[i + 1], i + 1) : null
          ));
          i += 1;
        }
      } else {
        for (var _i = 0; _i < totalLinks; _i += 1) {
          cols.push(_react2.default.createElement(
            'ul',
            { className: 'submenu-col submenu-row-3', key: 'subnav-' + _i },
            renderHelper(subnavLinks[_i], _i),
            subnavLinks[_i + 1] ? renderHelper(subnavLinks[_i + 1], _i + 1) : null,
            subnavLinks[_i + 2] ? renderHelper(subnavLinks[_i + 2], _i + 2) : null
          ));
          _i += 2;
        }
      }

      if (typeof content.subnavLinksL2 !== 'undefined') {
        cols.push(_react2.default.createElement(
          'ul',
          {
            className: 'submenu-col submenu-lvl2 submenu-lvl2-row-' + content.subnavLinksL2.length,
            key: 'subnav-lvl2'
          },
          content.subnavLinksL2.map(function (el, idx) {
            return renderHelper(el, idx);
          })
        ));
        colsClassname += ' lvl-2';
      }

      return _react2.default.createElement(
        'div',
        { className: colsClassname },
        cols
      );
    };

    _this.renderSubmenuGrouped = function (content) {
      var subnavLinks = content.subnavLinks;

      var cols = [];
      var totalLinks = subnavLinks.length;
      var colsClassname = 'submenu-cols';
      for (var i = 0; i < totalLinks; i += 1) {
        if (subnavLinks[i].group) {
          var links = subnavLinks[i].group.map(function (elem, idx) {
            return renderHelper(elem, idx);
          });

          cols.push(_react2.default.createElement(
            'ul',
            { className: 'submenu-col', key: 'subnav-' + i },
            links
          ));
        }
      }

      // TODO: Find a way to remove this boilerplate
      if (typeof content.subnavLinksL2 !== 'undefined') {
        cols.push(_react2.default.createElement(
          'ul',
          {
            className: 'submenu-col submenu-lvl2 submenu-lvl2-row-' + content.subnavLinksL2.length,
            key: 'subnav-lvl2'
          },
          content.subnavLinksL2.map(function (el, idx) {
            return renderHelper(el, idx);
          })
        ));
        colsClassname += ' lvl-2';
      }

      return _react2.default.createElement(
        'div',
        { className: colsClassname },
        cols
      );
    };

    _this.registerDropDown = _this.registerDropDown.bind(_this);
    _this.renderMobileCloser = _this.renderMobileCloser.bind(_this);
    _this.renderDesktopCloser = _this.renderDesktopCloser.bind(_this);
    _this.render = _this.render.bind(_this);
    _this.state = {
      indexAssigned: -2,
      locationMatched: false
    };
    return _this;
  }

  _createClass(MPPSubnav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /*
      * Highlight code except on '/home' page
      */
      /* eslint-disable react/no-did-mount-set-state */
      var currentLocation = window.location.pathname;
      if (/\/home$/.test(currentLocation)) return;

      var isLinkHighlighted = false;
      isLinkHighlighted = currentLocation.indexOf(this.props.content.href) !== -1;
      if (!isLinkHighlighted) {
        var subNavLinksArr = [].concat(_toConsumableArray(this.props.content.subnavLinks));
        // Check for L2 links to also include in highlight logic
        if (this.props.content.subnavLinksL2) {
          subNavLinksArr = subNavLinksArr.concat(this.props.content.subnavLinksL2);
        }

        isLinkHighlighted = subNavLinksArr.some(function (elem) {
          if (elem.group) {
            return elem.group.some(function (el) {
              return currentLocation.indexOf(el.href) !== -1;
            });
          }
          return currentLocation.indexOf(elem.href) !== -1;
        });
      }

      this.setState({
        locationMatched: isLinkHighlighted
      });
      /* eslint-enable react/no-did-mount-set-state */
    }
  }, {
    key: 'registerDropDown',
    value: function registerDropDown(elem) {
      var indexAssigned = this.props.register(elem);
      this.setState({ indexAssigned: indexAssigned });
    }
  }, {
    key: 'renderDesktopCloser',
    value: function renderDesktopCloser() {
      var minimalHeader = this.props.minimalHeader;

      return _react2.default.createElement(
        'span',
        { className: 'closer-desktop' },
        _react2.default.createElement(
          'button',
          {
            href: '#',
            className: 'closer',
            title: minimalHeader.labelClose,
            onClick: this.props.handlers.closeSubnav,
            'data-pa-click': 'HeaderSubnav-Link-close'
          },
          minimalHeader.labelClose
        )
      );
    }
  }, {
    key: 'renderMobileCloser',
    value: function renderMobileCloser() {
      var fpti = 'HeaderSubnav-Link-' + this.props.content.text;
      return _react2.default.createElement(
        'span',
        { className: 'closer-mobile' },
        _react2.default.createElement(
          'button',
          {
            href: '#',
            className: 'closer',
            onClick: this.props.handlers.closeSubnav,
            'data-pa-click': fpti
          },
          this.props.content.text
        )
      );
    }
  }, {
    key: 'renderSubmenu',
    value: function renderSubmenu(options) {
      var isOpen = options.isOpen,
          isClosing = options.isClosing,
          content = options.content;

      var isGrouped = this.props.grouped;
      return _react2.default.createElement(
        'div',
        { className: 'pp-header__subnav' },
        isOpen || isClosing ? this.renderMobileCloser() : '',
        isGrouped ? this.renderSubmenuGrouped(content) : this.renderSubmenuCols(content),
        isOpen ? this.renderDesktopCloser() : ''
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var content = this.props.content;

      var isOpen = this.props.activeLinkIndex === this.state.indexAssigned;
      var isClosing = this.props.closingLinkIndex === this.state.indexAssigned;

      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          {
            id: content.id,
            ref: this.registerDropDown,
            className: this.generateClassNames(isOpen, isClosing),
            href: content.href,
            'aria-controls': 'submenu-' + content.text,
            'aria-expanded': isOpen,
            onClick: this.props.handlers.handleMainLinks,
            onMouseEnter: this.props.handlers.handleMainLinksHover,
            onMouseLeave: this.props.handlers.handleMainLinksHover,
            'data-pa-click': 'HeaderMainMenu-Link-' + content.text
          },
          content.text
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'submenu-wrapper',
            id: 'submenu-' + content.text,
            'aria-labelledby': 'header-' + content.text,
            role: 'region',
            onMouseEnter: this.props.handlers.handleSubNavHover,
            onMouseLeave: this.props.handlers.handleSubNavHover
          },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            this.renderSubmenu({ isOpen: isOpen, isClosing: isClosing, content: content })
          )
        )
      );
    }
  }]);

  return MPPSubnav;
}(_react.Component);

MPPSubnav.propTypes = {
  register: _propTypes2.default.func.isRequired,
  handlers: _propTypes2.default.object.isRequired,
  minimalHeader: _propTypes2.default.object.isRequired,
  content: _propTypes2.default.object.isRequired,
  activeLinkIndex: _propTypes2.default.number.isRequired,
  closingLinkIndex: _propTypes2.default.number.isRequired,
  grouped: _propTypes2.default.bool
};

MPPSubnav.defaultProps = {
  grouped: false
};

exports.default = MPPSubnav;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/v3/MPPSubnav.js
// module id = 1101
// module chunks = 4